if (!customElements.get('ua-sticky-atc')) {
  customElements.define(
    'ua-sticky-atc',
    class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.productInfo = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
        this.button = this.querySelector('[data-ua-sticky-button]');
        this.label = this.querySelector('[data-ua-sticky-label]');
        this.price = this.querySelector('[data-ua-sticky-price]');
        this.minus = this.querySelector('[data-ua-sticky-minus]');
        this.plus = this.querySelector('[data-ua-sticky-plus]');
        this.quantity = this.querySelector('[data-ua-sticky-quantity]');
        this.mobile = window.matchMedia('(max-width: 989px)');
        this.frame = null;

        if (!this.productInfo || !this.button) return;

        this.button.addEventListener('click', () => this.activate());
        this.minus?.addEventListener('click', () => this.adjustQuantity(-1));
        this.plus?.addEventListener('click', () => this.adjustQuantity(1));
        this.mobile.addEventListener?.('change', () => this.updateVisibility());
        window.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
        window.addEventListener('resize', () => this.requestUpdate(), { passive: true });
        this.productInfo.addEventListener('change', () => this.requestRefresh());
        this.productInfo.addEventListener('input', () => this.requestRefresh());

        this.targetObserver = new MutationObserver(() => this.requestRefresh());
        this.targetObserver.observe(this.productInfo, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
          attributeFilter: ['disabled', 'class']
        });

        this.previewObserver = new MutationObserver(() => this.syncPreviewMode());
        this.previewObserver.observe(document.body, { childList: true });

        this.syncPreviewMode();
        this.refreshTargets();
        this.requestUpdate();
      }

      disconnectedCallback() {
        this.targetObserver?.disconnect();
        this.previewObserver?.disconnect();
        document.body.classList.remove('ua-sticky-atc-visible');
        document.body.classList.remove('ua-shopify-preview-bar');
      }

      requestRefresh() {
        if (this.refreshFrame) return;
        this.refreshFrame = window.requestAnimationFrame(() => {
          this.refreshFrame = null;
          this.refreshTargets();
        });
      }

      refreshTargets() {
        const nextSource = this.productInfo.querySelector('.product-form__submit[name="add"]');
        if (nextSource && nextSource !== this.sourceButton) {
          this.sourceButton = nextSource;
        }

        this.priceSource = this.productInfo.querySelector('[id^="price-"] .price-item--regular')
          || this.productInfo.querySelector('[id^="price-"] .price-item');
        this.quantitySource = this.productInfo.querySelector('.quantity__input');
        this.syncState();
        this.updateVisibility();
      }

      syncState() {
        if (!this.sourceButton) return;
        const sourceLabel = this.sourceButton.querySelector('span')?.textContent?.trim();
        if (sourceLabel) this.label.textContent = sourceLabel;
        if (this.priceSource?.textContent?.trim()) this.price.textContent = this.priceSource.textContent.trim();
        if (this.quantitySource?.value && this.quantity) this.quantity.textContent = this.quantitySource.value;
        this.button.disabled = this.sourceButton.disabled;
        this.button.setAttribute('aria-label', `${this.label.textContent.trim()} — ${this.price.textContent.trim()}`);
      }

      adjustQuantity(direction) {
        this.refreshTargets();
        if (!this.quantitySource) return;

        const current = Number(this.quantitySource.value) || 1;
        const minimum = Number(this.quantitySource.min) || 1;
        const maximum = Number(this.quantitySource.max) || Number.POSITIVE_INFINITY;
        const step = Number(this.quantitySource.step) || 1;
        const next = Math.min(maximum, Math.max(minimum, current + (step * direction)));

        this.quantitySource.value = String(next);
        this.quantitySource.dispatchEvent(new Event('input', { bubbles: true }));
        this.quantitySource.dispatchEvent(new Event('change', { bubbles: true }));
        if (this.quantity) this.quantity.textContent = String(next);
      }

      syncPreviewMode() {
        document.body.classList.toggle('ua-shopify-preview-bar', Boolean(document.getElementById('PBarNextFrame')));
      }

      activate() {
        this.refreshTargets();
        if (!this.sourceButton || this.sourceButton.disabled) {
          const choices = this.productInfo.querySelector('.product-form__input');
          choices?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.sourceButton.click();
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.updateVisibility();
        });
      }

      updateVisibility() {
        const shouldShow = this.mobile.matches && window.scrollY > 48;
        this.classList.toggle('is-visible', shouldShow);
        this.toggleAttribute('inert', !shouldShow);
        this.setAttribute('aria-hidden', String(!shouldShow));
        document.body.classList.toggle('ua-sticky-atc-visible', shouldShow);
      }
    }
  );
}
